import {UserId} from '@legit.health/ui';
import {DomainEvent} from '@/shared/contexts/EventDispatcherContext';

export const DIAGNOSTIC_REPORT_CREATED_EVENT = 'diagnosticReport.created';

type Payload = {
  patientId: UserId;
};

export type DiagnosticReportCreatedEvent = DomainEvent & Payload;

export function createDiagnosticReportCreatedEvent(payload: Payload): DiagnosticReportCreatedEvent {
  return Object.freeze({
    name: DIAGNOSTIC_REPORT_CREATED_EVENT,
    ...payload
  });
}
